import { render } from "./AppSign.vue?vue&type=template&id=a1c338ac&scoped=true"
import script from "./AppSign.vue?vue&type=script&lang=js"
export * from "./AppSign.vue?vue&type=script&lang=js"

import "./AppSign.vue?vue&type=style&index=0&id=a1c338ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c338ac"]])

export default __exports__